import React, { Component } from "react";
import { connect } from "react-redux";
import Immutable from "immutable";
import FontAwesome from "react-fontawesome";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { showHideModalEditStatus, getDataFromServer } from "../actions";

class ModalEditStatus extends Component {
  modalContent = () => {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <Input
              type="switch"
              reducer="reporte1"
              path="modalEditStatus.data.modify"
              label="Modificar estado a solicitudes fitradas"
              commentario="Al seleccionar esta opción las solicitudes filtradas modificaran&#13; su estado a PROCESADA"
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { modalEditStatus } = this.props;

    return (
      <Modal
        ancho="400px"
        mostrar={modalEditStatus.get("show")}
        contenido={this.modalContent()}
        titulo={`Modificación de estado de solicitudes`}
        nombre="modal_editar_estado_solicitud_reporte1"
        onCerrarModal={() => this.props.showHideModalEditStatus(false)}
        botones={
          <React.Fragment>
            <button
              className="btn btn-sm btn-primary"
              onClick={e => this.props.getDataFromServer(1, true)}
            >
              Aceptar
            </button>
          </React.Fragment>
        }
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalEditStatus: state.reporte1.get("modalEditStatus")
  };
};

const mapDispatchToProps = {
  showHideModalEditStatus,
  getDataFromServer
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditStatus);
